<ng-container [ngSwitch]="variant">
  <ng-container *ngSwitchCase="OmguiInteractiveCardVariant.Banner">
    <div class="card w-100 h-100 card-banner-variant" [ngClass]="classThemeMap[theme]">
      <div class="banner card-header border-0 d-flex flex-row align-items-center p-3 p-sm-4">
        <ng-container *ngIf="bannerPicture">
          <img class="pe-3 banner-picture" src="{{ bannerPicture }}" role="presentation" alt="" />
        </ng-container>
        <p class="h6 m-0" role="heading" [attr.aria-level]="headingLevel">
          {{ title }}
        </p>
      </div>

      <div class="card-body pb-0">
        <div class="card-text list-inline pb-0">
          <ng-container [ngTemplateOutlet]="bodyContent"></ng-container>
        </div>
      </div>

      <div class="card-footer border-0 bg-transparent pb-4 pt-1">
        <omgui-button
          variant="yellow-primary"
          size="fill-parent"
          data-cy="card-button"
          customButtonClass="p-2"
          [newTab]="buttonParams.newTab ?? false"
          [internalLink]="buttonParams.internalLink"
          [externalLink]="buttonParams.externalLink"
          [queryParams]="buttonParams.queryParams"
          [trackLink]="buttonParams.trackLink"
        >
          <ng-container [ngTemplateOutlet]="selectButtonContent"></ng-container>
        </omgui-button>
      </div>
    </div>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div class="card w-100 h-100" [ngClass]="classThemeMap[theme]">
      <div class="card-body pb-0">
        <p class="h6 card-title" role="heading" [attr.aria-level]="headingLevel">
          {{ title }}
        </p>

        <div class="card-text pt-2 pb-0">
          <ng-container [ngTemplateOutlet]="bodyContent"></ng-container>
        </div>
      </div>

      <div class="card-footer border-0 bg-transparent pb-4 pt-1">
        <omgui-button
          *ngIf="buttonParams.showButton !== false"
          variant="secondary"
          size="fill-parent"
          data-cy="card-button"
          [newTab]="buttonParams.newTab ?? false"
          [internalLink]="buttonParams.internalLink"
          [externalLink]="buttonParams.externalLink"
          [queryParams]="buttonParams.queryParams"
          [trackLink]="buttonParams.trackLink"
        >
          <ng-container [ngTemplateOutlet]="selectButtonContent"></ng-container>
        </omgui-button>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #bodyContent>
  <ng-content></ng-content>
</ng-template>

<ng-template #selectButtonContent>
  <ng-content select="[buttonContent]"></ng-content>
</ng-template>
